import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import News from '../views/news/News.vue'
import NewsDetail from '../views/news/NewsDetail.vue'
import About from '../views/About.vue'
import Info from '../views/Info.vue'
import Overview from '../views/Overview.vue'
import Research from '../views/Research.vue'
import Findings from '../views/Finding.vue'
import Surveys from '../views/surveys/Surveys.vue'
import SurveyDetail from '../views/surveys/SurveyDetail.vue'
import Laws from '../views/Laws.vue'
import Downloads from '../views/Downloads.vue'
import Links from '../views/Links.vue'
import NotFound from '../views/NotFound.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  // {
  //   path: '/en/home',
  //   name: 'enHome',
  //   component: Overview
  // },
  {
    path: '/news',
    name: 'news',
    component: News
  },
  {
    path: '/newsDetail/:id',
    name: 'newsDetail',
    component: NewsDetail,
    props: true
  },
  {
    path: '/about',
    name: 'about',
    component: About
  },
  {
    path: '/info',
    name: 'info',
    component: Info
  },
  {
    path: '/overview',
    name: 'overview',
    component: Overview
  },
  {
    path: '/research',
    name: 'research',
    component: Research
  },
  {
    path: '/en/findings',
    name: 'findings',
    component: Findings
  },
  {
    path: '/surveys',
    name: 'surveys',
    component: Surveys
  },
  {
    path: '/surveyDetail/:id',
    name: 'surveyDetail',
    component: SurveyDetail,
    props: true
  },
  {
    path: '/laws',
    name: 'laws',
    component: Laws
  },
  {
    path: '/links',
    name: 'links',
    component: Links
  },
  {
    path: '/downloads',
    name: 'downloads',
    component: Downloads
  },
  // catchall 404
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: NotFound
  }
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash && to.name != "research") {
      return {
        behavior: 'smooth',
      }
    }
    else return { top: 0, left: 0, behavior: "smooth"  }
  }
})

export default router
